class BookingStateManager{
    constructor(){

    };

    newBooking(activeAddress){
        var id =  generateUuid();
        var booking = {
            id : id,
            activeAddress : activeAddress,
            timeCreated : new Date(),
            lastModified : new Date(),
            url : {
                form : "form?id=" + id
            }
        }

        this.saveBookingState(booking);
        return booking;
    }

    loadBookingStateFromUrl(url){ // Returns Null if there is no bookingState
        const urlParams = extractParamsFromUrl(url);

        var bookingStateId =  urlParams.id
        if(bookingStateId){
            return loadBookingState(bookingStateId);
        }
        else {
            return null;
        }
    }
    

    saveBookingState(bookingState){
        bookingState.lastModified = new Date();

        var bookingStateBank = loadBookingStateBank();
        bookingStateBank[bookingState.id] = bookingState;
        localStorage.setItem("bookingStateBank", JSON.stringify(bookingStateBank));
    }

    deleteBookingState(id){
        var bookingStateBank = loadBookingStateBank();
        bookingStateBank[id] = null;
        localStorage.setItem("bookingStateBank", JSON.stringify(bookingStateBank));
    }

    upsertAddressMap(address){
        if(!address || !address.id){
            return
        }

        var addressMap = this.loadAddressMap()
        addressMap[address.id] = address
        this.saveAddressMap(addressMap)
    }
    getAddressFromMapById(addressId){
        var addressMap = this.loadAddressMap()
        var address = addressMap[addressId]

        return address
    }
    loadAddressMap() {
        var addressMap = localStorage.getItem('addressMap');
        if(typeof addressMap === "string"){
            try{
                addressMap = JSON.parse(addressMap) 
            }catch(err){
                
            }
        }

        if(!addressMap){
            addressMap = {}
        }
        
        return addressMap
    }
    saveAddressMap(addressMap = {}){
        localStorage.setItem('addressMap', JSON.stringify(addressMap))
    }

    cleanup() {
        // Remove expired booking state in storage
        const bank = JSON.parse(localStorage.bookingStateBank || '{}');
        const newBank = {};
        for (const stateId in bank) {
            if (bank.hasOwnProperty(stateId) && bank[stateId].lastModified) {
                const today = (new Date()).getTime();
                const time = today - (new Date(bank[stateId].lastModified)).getTime();
                const expirationDaysCount = (24*3600*1000); // 1 day

                // We don't want forms that's been more than a day old
                if ( parseInt((time) / expirationDaysCount) <= 1 ) {
                    // Retain forms that aren't more than a day
                    newBank[stateId] = bank[stateId];
                }
            }
        }

        localStorage.bookingStateBank = JSON.stringify(newBank);
    }
}

function extractParamsFromUrl(url){
    var result = {};
    url.replace(/[?&amp;]+([^=&amp;]+)=([^&amp;]*)/gi, function(str, key, value) {
        result[key] = value;
    }
    );
    return result;
}

function loadBookingState(bookingStateId){
    var bookingStateBank = loadBookingStateBank();
    return bookingStateBank[bookingStateId];
}

function loadBookingStateBank(){
    var bookingStateBank = localStorage.getItem("bookingStateBank");
    if(bookingStateBank){
        if(typeof bookingStateBank == 'string'){
            try{
                bookingStateBank = JSON.parse(bookingStateBank);
            }catch(err){
                bookingStateBank = {}
            }
        }
    }
    else{
        bookingStateBank = {};
    }
    return bookingStateBank;
}

function generateUuid(){
    var resourceString = "zyxwvutsrqonlkjihgfedcb1234567890";

    var returnString = "";

    for (let i = 0; i < 16; i++) {
        var index = Math.floor((Math.random() * resourceString.length));
        returnString += resourceString.charAt(index)
    }
    return returnString;
}

module.exports = BookingStateManager;